'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FieldValidation;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FieldValidation(props) {
  var validation = props.validation;


  return _react2.default.createElement(
    _text2.default,
    { color: 'red', size: 'extra-small', weight: 'semi-bold', multiline: true },
    validation.message
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/field-validation/field-validation.js
// module id = 317
// module chunks = 114276838955818